import {Component} from '@angular/core';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {createKitForm, mapKitToForm} from '../kit/kit.component';
import {ActivatedRoute, Router} from '@angular/router';
import {KitService} from '../../services/kit.service';
import {ToasterService} from 'angular2-toaster';
import {FileUploadFactoryService} from '../../services/file-upload-factory.service';

@Component({
  selector: 'app-kit-update',
  templateUrl: './kit-update.component.html',
  styleUrls: ['./kit-update.component.css']
})
export class KitUpdateComponent {

  kit;
  kitForm;
  styles;
  metaDataFields;
  selectedGroup = {};

  public thumbUploader:FileUploader = new FileUploader({url: ''});
  public bannerUploader:FileUploader = new FileUploader({url: ''});

  constructor(private activeRoute: ActivatedRoute,
              private router: Router,
              private fileUploadFactoryService: FileUploadFactoryService,
              private kitService: KitService, private toasterService: ToasterService) {



    let {styles, metaDataFields, kit} = this.activeRoute.snapshot.data['kitFields'];
    this.styles = styles;
    this.metaDataFields = metaDataFields;
    this.kit = kit;
    this.kitForm = createKitForm(kit);

    this.thumbUploader = fileUploadFactoryService.create(
      'file',
      FileUploadFactoryService.uploadUrl()
    );
    this.bannerUploader = fileUploadFactoryService.create(
      'file',
      FileUploadFactoryService.uploadUrl()
    );

    this.thumbUploader.onCompleteItem = (item: FileItem, response: string,
                                    status: number,
                                    headers: ParsedResponseHeaders) => {
      let r = JSON.parse(response);
      this.kitForm.thumbnail = `${r.path}`;
    };

    this.bannerUploader.onCompleteItem = (item: FileItem, response: string,
                                          status: number,
                                          headers: ParsedResponseHeaders) => {
      let r = JSON.parse(response);
      this.kitForm.banner = `${r.path}`;
    };
  }

  update() {
    this.kitService.update(this.kitForm).subscribe(updatedKit => {
      this.kitForm = mapKitToForm(updatedKit);
      this.toasterService.pop('success', 'Success', 'Kit updated');
      this.navigateToLibrary();
    }, error => {
      this.toasterService.pop('error', 'Error', error);
    })
  }

  navigateToLibrary() {
    console.log('navigating...');
    this.router.navigateByUrl('/dashboard/library');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/kit-update/kit-update.component.ts